import React from 'react';
import ModalModule from '../modal';
import Preview from './Preview.component';

const { Modal } = ModalModule;

const PreviewModal = ({ modalId, data }) => (
	<Modal
		modalId={modalId}
		header={data.modalTitle}
		className="common-branded-tracking-preview-modal"
		hideFooter
	>
		<Preview
			data={data.previewConfig}
			url={data.url}
			className={data.baseClass}
		/>
	</Modal>
);

export default PreviewModal;
